import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import refundService from '../../services/refund';

const initialState = {
  loading: false,
  refund: [],
  refundDate: null,
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchRefund = createAsyncThunk(
  'refund/fetchRefund',
  (params = {}) => {
    return refundService
      .commerceRefundsPaginate({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const refund = createSlice({
  name: 'review',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchRefund.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRefund.fulfilled, (state, action) => {
      const { payload } = action;
      const backend = payload?.data ?? payload;
      const list = Array.isArray(backend?.data) ? backend.data : (Array.isArray(backend) ? backend : []);
      const rawMeta = payload?.pagination ?? payload?.meta ?? backend?.meta ?? {};
      const meta = {
        current_page: rawMeta.current_page ?? rawMeta.page,
        per_page: rawMeta.per_page ?? rawMeta.perPage,
        total: rawMeta.total,
        lastPage: rawMeta.lastPage,
      };
      state.loading = false;
      state.refund = list ?? [];
      state.meta = meta;
      state.params.page = meta.current_page ?? state.params.page;
      state.params.perPage = meta.per_page ?? state.params.perPage;
      state.error = '';
      if (process.env.NODE_ENV === 'development') {
        console.log('[refund] fetchRefund response', { payloadData: payload?.data, listLength: list?.length, firstRefund: list?.[0] });
      }
    });
    builder.addCase(fetchRefund.rejected, (state, action) => {
      state.loading = false;
      state.refund = [];
      state.error = action.error.message;
    });
  },
});

export default refund.reducer;
